import { HTTPClient } from "@/utils/request.api";

export default {
  Lead: ({ payload }) => HTTPClient.post("Lead", payload),
  SemViabilidade: ({ payload }) => HTTPClient.post("SemViabilidade", payload),
  Autenticacao: ({ payload }) => HTTPClient.post("ValidarToken", payload),
  ReenvioToken: ({ payload }) => HTTPClient.post("ReenvioToken", payload),
  DadosPessoais: ({ payload }) => HTTPClient.post("DadosPessoais", payload),
  ComplementarDados: ({ payload }) =>
    HTTPClient.post("ComplementarDados", payload),
  ConsultarCep: ({ payload }) => HTTPClient.post("ConsultarCep", payload),
  Endereco: ({ payload }) => HTTPClient.post("Endereco", payload),
  Fatura: ({ payload }) => HTTPClient.post("Fatura", payload),
  Dependentes: ({ payload }) => HTTPClient.post("Dependentes", payload),
  Retomada: ({ payload }) =>
    HTTPClient.get(
      `Retomada?identificadorPedido=${payload.IdentificadorPedido}`
    ),
  AtualizarProduto: ({ payload }) =>
    HTTPClient.post("AtualizarProduto", payload),
};
